import { useState } from 'react';
import { Link } from 'react-router-dom';

const FAQ_ITEMS = [
  {
    q: '《健身教练》漫画真的可以免费阅读吗？',
    a: '可以。《健身教练》是073漫画网主推的免费漫画，全部章节都支持免费下拉式阅读，无需付费、无需下载，打开网页即可畅读。',
  },
  {
    q: '漫画支持哪些设备阅读？',
    a: '073漫画网支持电脑、手机和平板等所有设备访问，采用下拉式连续阅读模式，滑动屏幕即可阅读，手机端体验更佳。',
  },
  {
    q: '漫画多久更新一次？',
    a: '《健身教练》漫画保持每日更新，通常每天上午更新最新章节；其他连载漫画也保证每周至少更新 2-3 次，建议收藏后第一时间追更。',
  },
  {
    q: '阅读漫画需要注册账号吗？',
    a: '不需要。所有漫画均可直接免费阅读。如需收藏作品或发表评论，可以免费注册账号后使用，注册流程简单快捷。',
  },
  {
    q: '网站上的漫画从哪里来？是否侵权？',
    a: '本站漫画内容均来自网络公开渠道并仅作学习交流使用。如您是版权方并认为作品侵权，可通过"关于我们"页面中的联系方式与我们沟通，我们会在核实后第一时间处理。',
  },
];

const FAQ_JSONLD = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: FAQ_ITEMS.map((item) => ({
    '@type': 'Question',
    name: item.q,
    acceptedAnswer: { '@type': 'Answer', text: item.a },
  })),
};

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section className="bg-background-100/70 py-12 md:py-16" aria-label="常见问题">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <div className="text-center">
          <span className="text-xs font-medium uppercase tracking-widest text-primary-600">FAQ</span>
          <h2 className="mt-1 font-heading text-2xl text-foreground-950 md:text-3xl">常见问题</h2>
        </div>

        <div className="mt-8 space-y-3">
          {FAQ_ITEMS.map((item, idx) => {
            const open = openIndex === idx;
            return (
              <div
                key={idx}
                className="overflow-hidden rounded-lg border border-background-200 bg-background-50"
              >
                <h3>
                  <button
                    type="button"
                    onClick={() => setOpenIndex(open ? -1 : idx)}
                    aria-expanded={open}
                    className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left md:px-5"
                  >
                    <span className="text-sm font-medium text-foreground-950 md:text-base">{item.q}</span>
                    <span
                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary-100 text-primary-600 transition-transform ${
                        open ? 'rotate-45' : ''
                      }`}
                    >
                      <i className="ri-add-line" aria-hidden="true" />
                    </span>
                  </button>
                </h3>
                {open && (
                  <p className="px-4 pb-4 text-sm leading-relaxed text-foreground-700 md:px-5">
                    {item.a}
                  </p>
                )}
              </div>
            );
          })}
        </div>

        <p className="mt-6 text-center text-sm text-foreground-600">
          还有其他问题？欢迎访问
          <Link to="/about#contact" className="mx-1 font-medium text-primary-600 hover:text-primary-700">
            联系我们
          </Link>
          页面获取帮助。
        </p>
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(FAQ_JSONLD) }}
      />
    </section>
  );
}